export enum HOMETOWNS_DETAIL_TAB {
  GIFTS = 'gifts',
  PROJECTS = 'projects',
  POLICY = 'policy',
  CONTENTS = 'contents',
  REVIEWS = 'reviews',
  BENEFITS = 'benefits',
}

export const DEFAULT_GIFT_PRODUCT_SORT = 'POPULAR';

export const DEFAULT_GIFT_REVIEW_SORT = 'LATEST';

export const HOMETOWN_SECTION_PAGE_SIZE = 3;

//* 서버(page.tsx)와 클라이언트(GiftsContent)가 같은 값을 써야 SSR 목록이 클라 재요청으로 교체되지 않는다
export const GIFT_PRODUCT_PAGE_SIZE = 8;
